import { render, staticRenderFns } from "./HandleAppAlerts.vue?vue&type=template&id=4e33d9d8"
import script from "./HandleAppAlerts.vue?vue&type=script&lang=ts"
export * from "./HandleAppAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports